import { render, staticRenderFns } from "./AtributosFormModal.vue?vue&type=template&id=23dea1ae&scoped=true"
import script from "./AtributosFormModal.vue?vue&type=script&lang=js"
export * from "./AtributosFormModal.vue?vue&type=script&lang=js"
import style0 from "./AtributosFormModal.vue?vue&type=style&index=0&id=23dea1ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dea1ae",
  null
  
)

export default component.exports